import { render } from "./LotteryRecordList.vue?vue&type=template&id=70c84e8d&scoped=true"
import script from "./LotteryRecordList.vue?vue&type=script&lang=js"
export * from "./LotteryRecordList.vue?vue&type=script&lang=js"

import "./LotteryRecordList.vue?vue&type=style&index=0&id=70c84e8d&scoped=true&lang=css"

import exportComponent from "/Volumes/directory/IdeaProjects/Macau-Double-Color-Ball/Macau-Double-Color-Ball_Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c84e8d"]])

export default __exports__